import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import FormBuilder from './Components/Builder/FormBuilder';
import Homework from './Components/Test/HomeworkScreen';
import HomeScreen from "./Components/Home/HomeScreen"
import TestSession from './Components/Test/TestSession';
import { Layout1 } from './Components/Utility/Layout';
import Login from './Components/Auth/Login';
import SignUp from './Components/Auth/SignUp';
import { getCurrentUserId, getCurrentUserName, setCurrentUser } from './Backend/Auth/UserStore';
import { handleLogout } from './Backend/Auth/AuthService';
import { supabase } from './Backend/supabaseClient';
import AboutPage from './Components/About/AboutPage';


import QuestionPreview from './Components/Preview/QuestionPreview';
import { TestsProvider } from "./Components/Context/TestContext";
import ResponseViewer from './Components/Analysis/ResponseViewer';


export default function App() {
  // 1. FIREBASE USER STATE
  const [user, setFirebaseUser] = useState(null);


  // 3. UI STATES
  const [authLoading, setAuthLoading] = useState(false);
  const [globalNotice, setGlobalNotice] = useState(null);
  const [globalDialog, setGlobalDialog] = useState(null);

  const handleSetGlobalNotice = (notice) => setGlobalNotice(notice);
  const handleSetGlobalDialog = (dialog) => setGlobalDialog(dialog);

  useEffect(() => {
    // 1. Initial Check (Page Load)

    supabase.auth.getSession().then(({ data: { session } }) => {
      const u = session?.user ?? null;
      setFirebaseUser(u);
      setCurrentUser(u);        // ← add this
      setAuthLoading(false);
    });
    // 2. Real-time Subscription (Login/Logout events)
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      const u = session?.user ?? null;
      setFirebaseUser(u);
      setCurrentUser(u);        // ← add this
      setAuthLoading(false);
    });
    // Cleanup: Remove listener when app unmounts
    return () => subscription.unsubscribe();
  }, []);

  const activeUserName = getCurrentUserName();

  // --- LOADING SCREEN ---
  // Show this while onAuthStateChanged is running
  if (authLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-xl font-semibold">Loading...</div>
      </div>
    );
  }


  //                <HomeScreen setGlobalNotice={handleSetGlobalNotice} />

  return (
    <TestsProvider>
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <Layout1
                user={user}
                firstName={activeUserName}
                handleLogout={handleLogout}
                globalNotice={globalNotice}
                setGlobalNotice={handleSetGlobalNotice}
                dialog={globalDialog}
                setGlobalDialog={handleSetGlobalDialog}
              >
                <AboutPage />
              </Layout1>
            }
          />
          <Route
            path="/home"
            element={
              <Layout1
                user={user}
                firstName={activeUserName}
                handleLogout={handleLogout}
                globalNotice={globalNotice}
                setGlobalNotice={handleSetGlobalNotice}
                dialog={globalDialog}
                setGlobalDialog={handleSetGlobalDialog}
              >
                <HomeScreen setGlobalNotice={handleSetGlobalNotice} />
              </Layout1>
            }
          />
          <Route path="/analysis" element={<ResponseViewer />} />
          <Route path="/test/:testId" element={<TestSession />} />
          <Route
            path="/preview"
            element={
              <QuestionPreview />
            }
          />

          <Route
            path="/builder"
            element={
              <FormBuilder />
            }
          />

          <Route
            path="/login"
            element={
              <Layout1
                user={user}
                firstName={activeUserName}
                handleLogout={handleLogout}
                globalNotice={globalNotice}
                setGlobalNotice={handleSetGlobalNotice}
                dialog={globalDialog}
                setGlobalDialog={handleSetGlobalDialog}
              >
                <Login setGlobalNotice={handleSetGlobalNotice} />
              </Layout1>
            }
          />
          <Route
            path="/signup"
            element={
              <Layout1
                user={user}
                firstName={activeUserName}
                handleLogout={handleLogout}
                globalNotice={globalNotice}
                setGlobalNotice={handleSetGlobalNotice}
                dialog={globalDialog}
                setGlobalDialog={handleSetGlobalDialog}
              >
                <SignUp setGlobalNotice={handleSetGlobalNotice} />
              </Layout1>
            }
          />
        </Routes>
      </Router>
    </TestsProvider>
  );
}

